import React from 'react'

function AttendanceReports() {
  return (
    <div>AttendanceReports</div>
  )
}

export default AttendanceReports